export const grid = {
  item: {
    minWidth: '0',
  },
};
